<template>
  <div class="parallel-lines-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>L₁ // L₂ ⇔ ∠1 = ∠2 | 内错角 | 同位角$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <defs>
            <marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
              <path d="M 0 0 L 10 5 L 0 10 z" fill="#888" />
            </marker>
          </defs>

          <!-- Parallel Lines -->
          <line x1="50" :y1="100" x2="450" :y2="100" stroke="#00d2ff" stroke-width="3" />
          <line x1="50" :y1="200" x2="450" :y2="200" stroke="#00d2ff" stroke-width="3" />
          
          <!-- Parallel symbols -->
          <path d="M 240 90 L 250 100 L 240 110" fill="none" stroke="#00d2ff" stroke-width="2" />
          <path d="M 230 90 L 240 100 L 230 110" fill="none" stroke="#00d2ff" stroke-width="2" />
          <path d="M 240 190 L 250 200 L 240 210" fill="none" stroke="#00d2ff" stroke-width="2" />
          <path d="M 230 190 L 240 200 L 230 210" fill="none" stroke="#00d2ff" stroke-width="2" />

          <!-- Transversal Line -->
          <line :x1="250 - dx" y1="50" :x2="250 + dx" y2="250" stroke="#ff4757" stroke-width="2" />

          <!-- Angles -->
          <g v-if="showAngles">
             <!-- Corresponding angles -->
             <path d="M 250 100 l 30 0 a 30 30 0 0 0 -24 -24 z" fill="rgba(255, 215, 0, 0.4)" v-if="angleType === 'corresponding'" />
             <path d="M 268 200 l 30 0 a 30 30 0 0 0 -24 -24 z" fill="rgba(255, 215, 0, 0.4)" v-if="angleType === 'corresponding'" :transform="`translate(${angle2Offset}, 0)`" />
             
             <!-- Alternate interior -->
             <path d="M 232 100 l -30 0 a 30 30 0 0 0 24 24 z" fill="rgba(46, 213, 115, 0.4)" v-if="angleType === 'alternate'" :transform="`translate(${-angle1Offset}, 0)`" />
             <path d="M 268 200 l 30 0 a 30 30 0 0 0 -24 -24 z" fill="rgba(46, 213, 115, 0.4)" v-if="angleType === 'alternate'" :transform="`translate(${angle2Offset}, 0)`" />
          </g>

          <text x="60" y="90" fill="#00d2ff" font-size="14">L₁</text>
          <text x="60" y="190" fill="#00d2ff" font-size="14">L₂</text>
        </svg>

        <div class="hud-top">
          <div class="stat">
            <label>关系特征: {{ relationText }}</label>
          </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center gap-4">
            <div class="flex-1">
              <label>切换角度关系</label>
              <el-radio-group v-model="angleType" size="mini">
                <el-radio-button label="corresponding">同位角</el-radio-button>
                <el-radio-button label="alternate">内错角</el-radio-button>
                <el-radio-button label="co-interior">同旁内角</el-radio-button>
              </el-radio-group>
            </div>
            <div class="flex-1">
              <label>调节截线斜率 (观察角度联动)</label>
              <el-slider v-model="transAngle" :min="30" :max="150" size="mini"></el-slider>
            </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>平行线性质：</strong>两条平行线被第三条直线所截。其<strong>同位角相等</strong>、<strong>内错角相等</strong>、<strong>同旁内角互补</strong>（相加等于180°）。这是几何证明中最基础的判别依据。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParallelLinesViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      transAngle: 60,
      angleType: 'corresponding',
      showAngles: true
    }
  },
  computed: {
    dx() { return 100 * Math.cos(this.transAngle * Math.PI / 180); },
    angle1Offset() { return 0; },
    angle2Offset() { return 0; },
    relationText() {
       const map = { corresponding: '同位角相等', alternate: '内错角相等', 'co-interior': '同旁内角互补' };
       return map[this.angleType];
    }
  }
}
</script>

<style scoped lang="scss">
.parallel-lines-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
.row { display: flex; gap: 20px; align-items: center; }
label { font-size: 0.75rem; color: #888; margin-bottom: 5px; display: block; }
.flex-1 { flex: 1; }
</style>
